var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_2266)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13377 0.0390625H18.8662C19.4684 0.0390625 19.9612 0.533965 19.9612 1.1389V12.8609C19.9612 13.4658 19.4686 13.9609 18.8662 13.9609H1.13377C0.531718 13.9609 0.0388794 13.466 0.0388794 12.8609V1.1389C0.0388794 0.533965 0.531718 0.0390625 1.13377 0.0390625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13377 0.0390625H18.8662C19.4684 0.0390625 19.9612 0.533965 19.9612 1.1389V9.36389H0.0388794V1.1389C0.0388794 0.533965 0.531718 0.0390625 1.13377 0.0390625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13377 0.0390625H18.8662C19.4684 0.0390625 19.9612 0.533965 19.9612 1.1389V4.63608H0.0388794V1.1389C0.0388794 0.533965 0.531718 0.0390625 1.13377 0.0390625Z",
    fill: "#0072CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13379 0H18.8662C19.1779 0 19.4613 0.128181 19.6668 0.334513C19.8726 0.541172 20 0.825818 20 1.13891V12.8609C20 13.174 19.8726 13.4588 19.667 13.6653C19.4613 13.8718 19.1779 14 18.8662 14H1.13379C0.822266 14 0.538737 13.8718 0.333171 13.6653C0.127604 13.459 0 13.1742 0 12.8609V1.13891C0 0.825655 0.127604 0.540845 0.333008 0.334513C0.538737 0.128181 0.822266 0 1.13379 0ZM18.8662 0.0783146H1.13379C0.843424 0.0783146 0.579427 0.197503 0.388184 0.389775C0.196777 0.582046 0.0779622 0.8474 0.0779622 1.13891V12.8609C0.0779622 13.1526 0.196777 13.4178 0.388184 13.6101C0.579427 13.8025 0.843424 13.9217 1.13379 13.9217H18.8662C19.1566 13.9217 19.4206 13.8023 19.612 13.6102C19.8034 13.418 19.9222 13.1526 19.9222 12.8609V1.13891C19.9222 0.847236 19.8034 0.581882 19.612 0.389611C19.4206 0.19734 19.1566 0.0783146 18.8662 0.0783146Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_2266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.96335b1a4af808cb705e99230ee5a4e0.svg";
export { ForwardRef as ReactComponent };